<script setup lang="ts">
  import { ref } from 'vue';

  defineOptions({
    inheritAttrs: false,
  });

  defineProps({
    header: String,
    products: Array,
    headerType: String,
    link: String,
    enableAutoplay: Boolean,
    timeAutoplay: [Number, String],
    speed: [Number, String],
  });

  const parameters = ref({
    breakpoints: {
      1: {
        slidesPerView: 1.5,
        spaceBetween: 10,
        slidesOffsetBefore: 10,
        slidesOffsetAfter: 10,
      },
      576: {
        slidesPerView: 2.5,
        spaceBetween: 10,
        slidesOffsetBefore: 10,
        slidesOffsetAfter: 10,
      },
      768: {
        slidesPerView: 3.5,
        spaceBetween: 10,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
      1400: {
        slidesPerView: 5,
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
    },
  });
</script>
<template>
  <SfSection :headerType :link="link || $route('web.product.index')" :title="header">
    <SfProductsCarousel :parameters :products :enableAutoplay :timeAutoplay :speed />
  </SfSection>
</template>
